import script from "./StarRating.vue?vue&type=script&setup=true&lang=js"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=1c5755f5&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5755f5"]])

export default __exports__